import React from 'react'
import PropTypes from 'prop-types'
import numberConverter from '../../../../../../utils/tuition/numberForCurrency'

const CareerNodeTooltip = ({ activeNode, visibility, x, y }) => {
  const style = {
    left: `${x}px`,
    top: `${y}px`,
    visibility,
  }
  return(
    <div id="CareerNodeTooltip" className="wheel-tooltip shadow text-center" style={style}>
      <h5 style={{ marginBottom: 0}}>{activeNode.name} </h5>
      { activeNode.company_or_university && <h6>@{ activeNode.company_or_university }</h6>}
      {activeNode.salary && <h6 style={{marginBottom: 0}}>
        <strong>Est. Salary:</strong> ${numberConverter(activeNode.salary)}
      </h6>}
    </div>
  )
}

CareerNodeTooltip.propTypes = {
  activeNode: PropTypes.object,
  visibility: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
}

export default CareerNodeTooltip



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/CareerNodeTooltip.js